import { resolvePlanPrice } from './planAnnualPricing';

/** Preços SaaS da seção E-commerce — valores numéricos por moeda e ciclo. */

export const ECOMMERCE_PLAN_PRICES = {
  start: {
    monthly: { BRL: 497, EUR: 79, USD: 99 },
    annual: { BRL: 4970, EUR: 790, USD: 990 }
  },
  growth: {
    monthly: { BRL: 997, EUR: 179, USD: 219 },
    annual: { BRL: 9970, EUR: 1790, USD: 2190 }
  },
  premium: {
    monthly: { BRL: 2497, EUR: 399, USD: 499 },
    annual: { BRL: 24970, EUR: 3990, USD: 4990 },
    plus: true
  }
};

export function getDefaultEcommerceCurrency(language) {
  if (language === 'pt-BR') return 'BRL';
  if (language === 'pt-PT') return 'EUR';
  return 'USD';
}

const formatterCache = new Map();

function getNumberFormatter(locale) {
  if (!formatterCache.has(locale)) {
    formatterCache.set(
      locale,
      new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    );
  }
  return formatterCache.get(locale);
}

export function formatEcommercePlanPrice(amount, currency, cycle, opts = {}) {
  const { plus = false, language = 'pt-BR' } = opts;
  const suffix = plus ? '+' : '';
  const isEn = language === 'en' || (language && !String(language).startsWith('pt'));
  const periodMonthly = isEn ? '/mo' : '/mês';
  const periodAnnual = isEn ? '/yr' : '/ano';
  const period = cycle === 'monthly' ? periodMonthly : periodAnnual;

  const n = getNumberFormatter(
    currency === 'BRL' ? 'pt-BR' : currency === 'EUR' ? 'pt-PT' : 'en-US'
  ).format(amount);

  if (currency === 'BRL') return `R$ ${n}${period}${suffix}`;
  if (currency === 'EUR') return `${n} €${period}${suffix}`;
  return `US$ ${n}${period}${suffix}`;
}

export function getEcommercePlanPrice(planKey, currency, cycle, language) {
  return resolvePlanPrice({
    plan: ECOMMERCE_PLAN_PRICES[planKey],
    currency,
    cycle,
    language,
    formatPrice: formatEcommercePlanPrice
  });
}
